import { useApiResource } from "@/hooks/useApiResource";
import type { Gasto, Vinculables } from "@/lib/api";
import { opcionesCuota, opcionesItem, opcionesPresupuesto, presupuestoElegido } from "@/lib/facturas";
import type { FormGasto } from "@/lib/gastos";
import { SIN_VALOR } from "@/lib/proveedores";

export interface VinculosFactura {
  vinculables: Vinculables | null;
  opcionesPresupuesto: ReturnType<typeof opcionesPresupuesto>;
  opcionesCuota: ReturnType<typeof opcionesCuota>;
  opcionesItem: ReturnType<typeof opcionesItem>;
}

/**
 * Lo que el form de la factura ofrece para vincularla (sin JSX): los presupuestos aceptados del proveedor elegido con
 * su plan y los ítems del rubro. `activo`: sólo el admin, con el form abierto. `actual`: la factura que se edita.
 */
export function useVinculosFactura(fid: number, form: FormGasto, activo: boolean, actual?: Gasto | null): VinculosFactura {
  const proveedor = form.proveedor_id && form.proveedor_id !== SIN_VALOR ? form.proveedor_id : null;
  const recurso = useApiResource<Vinculables>(activo ? `/api/fideicomisos/${fid}/gastos/vinculables${proveedor ? `?proveedor_id=${proveedor}` : ""}` : null);
  const v = recurso.data ?? null;
  const p = presupuestoElegido(v, form.cotizacion_id);
  const mismo = actual && String(actual.cotizacion?.id ?? "") === form.cotizacion_id;
  const mismoProveedor = actual && String(actual.proveedor?.id ?? "") === form.proveedor_id;
  return {
    vinculables: v,
    opcionesPresupuesto: opcionesPresupuesto(v, mismoProveedor ? actual?.cotizacion : null),
    opcionesCuota: opcionesCuota(p, mismo ? actual?.cuota : null),
    opcionesItem: opcionesItem(v?.items ?? [], form.rubro_id, p?.items, actual && String(actual.rubro.id) === form.rubro_id ? actual.item : null),
  };
}
